// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICodeRequestDto
 */
export interface ICodeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ICodeRequestDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ICodeRequestDto
     */
    session?: string;
    /**
     * 
     * @type {string}
     * @memberof ICodeRequestDto
     */
    communication_type?: ICodeRequestDtoCommunicationTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ICodeRequestDto
     */
    is_remember_me?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ICodeRequestDto
     */
    client_type?: ICodeRequestDtoClientTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICodeRequestDtoCommunicationTypeEnum {
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}
/**
* @export
* @enum {string}
*/
export enum ICodeRequestDtoClientTypeEnum {
    WEB_APP = 'WEB_APP',
    MOBILE_APP = 'MOBILE_APP',
    PARTNER_SSO = 'PARTNER_SSO',
    MANAGE_PROFILE = 'MANAGE_PROFILE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD'
}


/**
 * Check if a given object implements the ICodeRequestDto interface.
 */
export function instanceOfICodeRequestDto(value: object): value is ICodeRequestDto {
    return true;
}

export function ICodeRequestDtoFromJSON(json: any): ICodeRequestDto {
    return ICodeRequestDtoFromJSONTyped(json, false);
}

export function ICodeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICodeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'session': json['session'] == null ? undefined : json['session'],
        'communication_type': json['communication_type'] == null ? undefined : json['communication_type'],
        'is_remember_me': json['is_remember_me'] == null ? undefined : json['is_remember_me'],
        'client_type': json['client_type'] == null ? undefined : json['client_type'],
    };
}

export function ICodeRequestDtoToJSON(json: any): ICodeRequestDto {
    return ICodeRequestDtoToJSONTyped(json, false);
}

export function ICodeRequestDtoToJSONTyped(value?: ICodeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'session': value['session'],
        'communication_type': value['communication_type'],
        'is_remember_me': value['is_remember_me'],
        'client_type': value['client_type'],
    };
}

